import React from "react";
import { Grid, makeStyles, Typography, Box, Button } from "@material-ui/core";

import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import { ColorService } from "../../../../services/color.service";

const usetSyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(2),
    textAlign: "left",
  },
}));

const ModalAddColor = ({ openModal, addAlert, detailAlert }) => {
  const classes = usetSyles();
  const [colorObject, setColorObject] = React.useState({});
  const [disabledButton, setDisabledButton] = React.useState(false);

  const submitColorForm = () => {
    ColorService.postColor(colorObject)
      .then((result) => {
        setTimeout(() => {
          openModal(false);
        }, 2000);
        setDisabledButton(true);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "success",
          message: "Color agregado  exitosamente",
          time: 2000,
        });
      })
      .catch((error) => {
        console.log(error.msgs);
        openModal(false);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: error.msgs,
        });
      });
  };

  return (
    <React.Fragment>
      <ValidatorForm
        noValidate
        className={classes.form}
        method="POST"
        onSubmit={submitColorForm}
        onError={(errors) => console.log(errors)}
      >
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item xs={12} sm={12} md={6} lg={12} xl={12}>
            <Box mb={2}>
              <Typography
                variant="h5"
                component="span"
                style={{ color: "#0b148e", fontWeight: "bold" }}
              >
                Agregar nuevo color
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextValidator
              name="name"
              value={colorObject.name || ""}
              validators={["required"]}
              onChange={(e) =>
                setColorObject({
                  ...colorObject,
                  [e.target.name]: e.target.value.toUpperCase(),
                })
              }
              errorMessages={["El campo es obligatorio"]}
              variant="outlined"
              inputProps={{
                maxLength: 30,
              }}
            ></TextValidator>
          </Grid>

          <Grid item>
            <Box mt={5}>
              <Button
                color="primary"
                style={{ marginRight: 50, width: 150 }}
                disabled={disabledButton}
                onClick={() => {
                  setColorObject({
                    ...colorObject,
                    name: "",
                  });
                  openModal(false);
                }}
              >
                Cancelar
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <Box mt={5}>
              <Button
                color="primary"
                disabled={disabledButton}
                style={{ width: 150 }}
                variant="contained"
                type="submit"
              >
                Aceptar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </ValidatorForm>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ModalAddColor);
